//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useEffect, useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { useParams, useHistory, useLocation } from 'react-router-dom';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { logPageView } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import {
    PATH_SUB_PAGE_FAQ,
    PATH_SUB_PAGE_TERMS,
    PATH_SUB_PAGE_MESSAGE,
    PATH_SUB_PAGE_PRIVACY,
    PATH_HOME,
    PATH_SUB_PAGE_EMPLOYERS,
    PATH_SUB_PAGE_JOB_SEEKER,
    PATH_SUB_PAGE_JITSI,
} from '../../system/constants';
import { BASE_URL, HOMEPAGE_ABOUT, HOMEPAGE_CONTACT, PAGE_TITLE_JITSI, PAGE_TITLE_MESSAGE, PAGE_TITLE_PRIVACY, PAGE_TITLE_TERMS } from '../../common/constants';
import { setClassNameInDefns } from '../../common/definitionHelper';
import FaqContent from './subFaqComponents/FaqContent';
import TermsOfUse from './subFaqComponents/TermsOfUse';
import PrivacyPolicy from './subFaqComponents/PrivacyPolicy';
import { LayoutContext } from '../../common/contexts';
import TheMessage from './subFaqComponents/TheMessage';
import JobSeeker from './subFaqComponents/JobSeeker';
import Employers from './subFaqComponents/Employers';
import ShoutOutToJitsi from './subFaqComponents/Jitsi';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    const sidebarStyles = {
        fontWeight: 'bold',
        fontSize: 18,
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 15,
        cursor: 'pointer',
        borderLeft: '4px solid rgba(255, 255, 255, 1)',
        '&:hover': { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' },
    };
    const dropDownSideBar = {
        fontWeight: 'bold',
        fontSize: 15,
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 25,
        cursor: 'pointer',
        '&:hover': { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3 },
    };
    return makeStyles(theme => ({
        root: {},
        aboutUsContainer: {
            display: 'flex',
            justifyContent: 'center',
            marginTop: 32,
            [theme.breakpoints.down('md')]: { marginTop: 16 },
        },
        aboutUsSidebar: {
            // maxWidth: 320,
            paddingTop: 10,
            background: 'white',
            borderRadius: '10px',
            marginRight: 24,
            [theme.breakpoints.down('md')]: { marginRight: 0 },
            position: 'relative',
        },
        aboutUsSidebarContent: {
            height: 630,
            [theme.breakpoints.down('md')]: { height: '700px' },
            [theme.breakpoints.down('sm')]: { height: '740px' },
            // overflowY: 'scroll',
            // overflowX: 'hidden',
            // '&::-webkit-scrollbar-track': {
            //     borderRadius: '10px',
            //     background: 'none',
            // },
            // '&::-webkit-scrollbar': {
            //     width: '8px',
            //     backgroundColor: '#F5F5F5',
            // },
            // '&::-webkit-scrollbar-thumb': {
            //     borderRadius: '10px',
            //     backgroundColor: 'rgba(0,0,0,0.2)',
            // },
        },
        aboutUsProfileContainer: {
            padding: 10,
            background: 'white',
            borderRadius: 10,
        },
        aboutUsContent: {
            padding: '0px 20px',
            overflowY: 'scroll',
            overflowX: 'hidden',
            height: 530,
            [theme.breakpoints.down('md')]: { height: '700px' },
            '&::-webkit-scrollbar-track': {
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
        AboutUsProfileText: { fontSize: 16, fontWeight: 400 },
        sidebarHeading: {
            ...sidebarStyles,
        },
        faqSidebarHeading: {
            ...sidebarStyles,
        },
        privacySidebarHeading: {
            ...sidebarStyles,
        },
        jitsiSidebarHeading: {
            ...sidebarStyles,
        },
        termsSidebarHeading: {
            ...sidebarStyles,
        },
        messageSidebarHeading: {
            ...sidebarStyles,
        },
        jobSeekerSidebarHeading: {
            ...dropDownSideBar,
        },
        employersSidebarHeading: {
            ...dropDownSideBar,
        },
        navigation: { marginTop: 16 },
        navigationButtonContainer: { display: 'flex', alignItems: 'center' },
        navigationIconContainer: {
            width: '32px',
            height: '32px',
            background: '#F2F2F4',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            '&:hover': { cursor: 'pointer' },
        },
        navIconLeft: { marginLeft: 11, width: 18 },
        navigationText: { marginLeft: 8, fontSize: 16, fontWeight: 'bold', '&:hover': { cursor: 'pointer' }, marginTop: '-2px' },
        bottomLinksContainer: {
            position: 'absolute',
            bottom: '-40px',
            left: 0,
            fontSize: 13,
            color: 'rgba(17, 30, 20, 0.4)',
            [theme.breakpoints.down('sm')]: { position: 'unset', bottom: 'unset', left: 'unset', textAlign: 'center', marginBottom: '-40px' },
        },
        bottomLink: { cursor: 'pointer' },
        copyRightDate: {
            position: 'absolute',
            bottom: '-40px',
            right: 16,
            fontSize: 11,
            color: 'rgba(17, 30, 20, 0.4)',
            [theme.breakpoints.down('sm')]: { bottom: '-55px', right: '48%' },
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, setOpenRightPageContent, OpenRightPageContent, history, location, faqPage } = params;

    const defns = {
        aboutUsContainer: { container: true },
        aboutUsSidebar: { item: true, xl: 3, lg: 4, md: 11, sm: 11, xs: 11 },
        navigation: { container: true, direction: 'row', justify: 'center' },
        navigationItem: { item: true, xl: 3, lg: 4, md: 11, sm: 11, xs: 11 },
        OpenRightPageContent: {
            onClick: () => {
                setOpenRightPageContent(!OpenRightPageContent);
            },
        },
        navigationIconContainer: {
            onClick: () => {
                setOpenRightPageContent(false);
                history.replace({ ...location, state: {} });
            },
        },
        navigationText: {
            onClick: () => {
                setOpenRightPageContent(!OpenRightPageContent);
            },
        },
        faqRoute: {
            onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_FAQ),
        },
        faqSidebarHeading: {
            onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_FAQ),
            style:
                faqPage === PATH_SUB_PAGE_FAQ || faqPage === PATH_SUB_PAGE_JOB_SEEKER || faqPage === PATH_SUB_PAGE_EMPLOYERS
                    ? { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' }
                    : { color: 'black' },
        },
        jobSeekerSidebarHeading: {
            onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_JOB_SEEKER),
            style: faqPage === PATH_SUB_PAGE_JOB_SEEKER ? { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3 } : { color: 'black' },
        },
        employersSidebarHeading: {
            onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_EMPLOYERS),
            style: faqPage === PATH_SUB_PAGE_EMPLOYERS ? { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3 } : { color: 'black' },
        },
        // privacyRoute: {
        //     onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_PRIVACY),
        // },
        privacySidebarHeading: {
            onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_PRIVACY),
            style: faqPage === PATH_SUB_PAGE_PRIVACY ? { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' } : { color: 'black' },
        },
        jitsiSidebarHeading: {
            onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_JITSI),
            style: faqPage === PATH_SUB_PAGE_JITSI ? { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' } : { color: 'black' },
        },

        // termsRoute: {
        //     onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_TERMS),
        // },
        termsSidebarHeading: {
            onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_TERMS),
            style: faqPage === PATH_SUB_PAGE_TERMS ? { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' } : { color: 'black' },
        },
        // messageRoute: {
        //     onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_MESSAGE),
        // },
        messageSidebarHeading: {
            onClick: handleClickButton.bind(null, history, PATH_SUB_PAGE_MESSAGE),
            style: faqPage === PATH_SUB_PAGE_MESSAGE ? { background: 'rgba(0, 0, 0, 0.03)', borderRadius: 3, borderLeft: '4px solid #1D8A8B' } : { color: 'black' },
        },

        aboutUsRoute: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_ABOUT}`),
        },
        contactUsRoute: {
            onClick: handleClickButton.bind(null, history, `${PATH_HOME}/${HOMEPAGE_CONTACT}`),
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const getLayoutComponent = (faqPage, faqSubLink) => {
    switch (faqPage) {
        case PATH_SUB_PAGE_FAQ:
            return <FaqContent faqSubLink={faqSubLink} />;
        case PATH_SUB_PAGE_TERMS: {
            logPageView(PAGE_TITLE_TERMS);
            return <TermsOfUse />;
        }
        case PATH_SUB_PAGE_MESSAGE: {
            logPageView(PAGE_TITLE_MESSAGE);
            return <TheMessage />;
        }
        case PATH_SUB_PAGE_PRIVACY: {
            logPageView(PAGE_TITLE_PRIVACY);
            return <PrivacyPolicy />;
        }
        case PATH_SUB_PAGE_JITSI: {
            logPageView(PAGE_TITLE_JITSI);
            return <ShoutOutToJitsi />;
        }
        case PATH_SUB_PAGE_JOB_SEEKER:
            return <JobSeeker />;
        case PATH_SUB_PAGE_EMPLOYERS:
            return <Employers />;
        default:
            return <TheMessage />;
    }
};

const handleClickButton = (history, path) => {
    history.push(`${BASE_URL}${path}`);
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Faq = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const { subPageId = PATH_SUB_PAGE_FAQ } = useParams();
    // console.log(`Add this console log to avoid eslint warning.  Remove this when the subPageId is being used. ${subPageId}`);
    const history = useHistory();
    const location = useLocation();
    const fromDrawer = _get(location, 'state.fromDrawer', false);

    const theme = useTheme();
    const mdMatches = useMediaQuery(theme.breakpoints.down('md'));
    const lgMatches = useMediaQuery(theme.breakpoints.down('lg'));
    const lgUpMatches = useMediaQuery(theme.breakpoints.up('lg'));

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;
    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    const [OpenRightPageContent, setOpenRightPageContent] = useState(false);

    const [OpenFaqDropdown, setOpenFaqDropdown] = useState(false);
    const [faqPage, setFaqPage] = useState(subPageId);
    const [faqSubLink /*setFaqSubLink*/] = useState('Frequently Asked Questions');

    // console.log(faqSubLink);
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        switch (subPageId) {
            case PATH_SUB_PAGE_FAQ:
                setFaqPage(PATH_SUB_PAGE_FAQ);
                break;
            case PATH_SUB_PAGE_TERMS:
                setFaqPage(PATH_SUB_PAGE_TERMS);
                break;
            case PATH_SUB_PAGE_MESSAGE:
                setFaqPage(PATH_SUB_PAGE_MESSAGE);
                break;
            case PATH_SUB_PAGE_PRIVACY:
                setFaqPage(PATH_SUB_PAGE_PRIVACY);
                break;
            case PATH_SUB_PAGE_JITSI:
                setFaqPage(PATH_SUB_PAGE_JITSI);
                break;
            case PATH_SUB_PAGE_JOB_SEEKER:
                setFaqPage(PATH_SUB_PAGE_JOB_SEEKER);
                break;
            case PATH_SUB_PAGE_EMPLOYERS:
                setFaqPage(PATH_SUB_PAGE_EMPLOYERS);
                break;
            default:
                setFaqPage(PATH_SUB_PAGE_FAQ);
        }
    }, [subPageId]);

    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, setOpenRightPageContent, OpenRightPageContent, history, location, OpenFaqDropdown, setOpenFaqDropdown, faqPage });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div>
            {/* back button 768 */}
            {(mdMatches && OpenRightPageContent) || fromDrawer ? (
                <Grid {...defns.navigation}>
                    <Grid {...defns.navigationItem}>
                        <div {...defns.navigationButtonContainer} onClick={() => setOpenFaqDropdown(false)}>
                            <div {...defns.navigationIconContainer}>
                                <ArrowBackIosIcon {...defns.navIconLeft} />
                            </div>
                            <span {...defns.navigationText}>Back</span>
                        </div>
                    </Grid>
                </Grid>
            ) : null}

            {/* main container */}
            <Grid {...defns.aboutUsContainer}>
                {/* sidebar */}
                {(mdMatches && OpenRightPageContent) || fromDrawer ? null : (
                    <Grid {...defns.aboutUsSidebar}>
                        <div {...defns.aboutUsSidebarContent}>
                            <div {...defns.sidebarItem}>
                                <span {...defns.OpenRightPageContent}>
                                    <p {...defns.messageSidebarHeading}>The Message</p>
                                </span>
                            </div>
                            {/* <div {...defns.sidebarItem}>
                                {OpenFaqDropdown ? (
                                    <>
                                        <span {...defns.OpenRightPageContent}>
                                            <span {...defns.faqRoute}>
                                                <span {...defns.handleOpenFaqDropdown}>
                                                    <span
                                                        onClick={() => {
                                                            setFaqSubLink('Frequently Asked Questions');
                                                        }}
                                                    >
                                                        <p {...defns.faqSidebarHeading} onClick={() => setOpenFaqDropdown(!OpenFaqDropdown)}>
                                                            Frequently Asked Questions
                                                        </p>
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                    </>
                                ) : (
                                    <>
                                        <span {...defns.faqRoute}>
                                            <span {...defns.handleOpenFaqDropdown}>
                                                <span
                                                    onClick={() => {
                                                        setFaqSubLink('Frequently Asked Questions');
                                                    }}
                                                >
                                                    <p {...defns.faqSidebarHeading} onClick={() => setOpenFaqDropdown(!OpenFaqDropdown)}>
                                                        Frequently Asked Questions
                                                    </p>
                                                </span>
                                            </span>
                                        </span>
                                    </>
                                )}

                                {OpenFaqDropdown ? (
                                    <div {...defns.sidebarDropDrown}>
                                        <span {...defns.OpenRightPageContent}>
                                            <p {...defns.jobSeekerSidebarHeading}>Job Seekers</p>
                                        </span>
                                        <span {...defns.OpenRightPageContent}>
                                            <p {...defns.employersSidebarHeading}>Employers</p>
                                        </span>
                                    </div>
                                ) : null}
                            </div> */}
                            <div {...defns.sidebarItem}>
                                <span {...defns.OpenRightPageContent}>
                                    <p {...defns.termsSidebarHeading}>Terms of Use</p>
                                </span>
                            </div>
                            <div {...defns.sidebarItem}>
                                <span {...defns.OpenRightPageContent}>
                                    <p {...defns.privacySidebarHeading}>Privacy Policy</p>
                                </span>
                            </div>
                            <div {...defns.sidebarItem}>
                                <span {...defns.OpenRightPageContent}>
                                    <p {...defns.jitsiSidebarHeading}>Shout out to Jitsi</p>
                                </span>
                            </div>
                        </div>

                        {/* sidebar bottom links for sm-lg */}
                        {lgMatches ? (
                            <>
                                <div {...defns.bottomLinksContainer}>
                                    <p>
                                        <span {...defns.bottomLink}>
                                            <span {...defns.aboutUsRoute}>About Us</span>
                                        </span>
                                        /{' '}
                                        <span {...defns.bottomLink}>
                                            <span {...defns.OpenRightPageContent}>
                                                <span {...defns.termsRoute}>Terms</span>
                                            </span>
                                        </span>
                                        /{' '}
                                        <span {...defns.bottomLink}>
                                            <span {...defns.OpenRightPageContent}>
                                                <span {...defns.privacyRoute}>Privacy</span>
                                            </span>
                                        </span>
                                        /{' '}
                                        <span {...defns.bottomLink}>
                                            <span {...defns.contactUsRoute}>Contact Us</span>
                                        </span>
                                    </p>
                                </div>
                                {/* sidebar bottom links for md down*/}
                                {mdMatches ? <p {...defns.copyRightDate}>©2020</p> : null}
                            </>
                        ) : null}
                    </Grid>
                )}

                {/* content section */}
                {(mdMatches && OpenRightPageContent) || fromDrawer ? getLayoutComponent(faqPage, faqSubLink) : lgUpMatches ? getLayoutComponent(faqPage, faqSubLink) : null}
            </Grid>
        </div>
    );
};

export default Faq;
